module.exports = __webpack_public_path__ + "static/media/covid.c9367a35.webp";